export const modelListSelector = state =>
  state.getIn(['app', 'mra', 'mra', 'modelList']);
export const modelsSelector = state =>
  state.getIn(['app', 'mra', 'mra', 'models']);
export const modelSettingsSelector = state =>
  state.getIn(['app', 'mra', 'mra', 'modelSettings']);
export const analysisModelsSelector = state =>
  state.getIn(['app', 'mra', 'mra', 'analysisModels']);
export const analysisNoiModelsSelector = state =>
  state.getIn(['app', 'mra', 'mra', 'analysisNoiModels']);
export const selectedModelIdSelector = state =>
  state.getIn(['app', 'mra', 'mra', 'selectedModelId']);
export const calculateStateSelector = state =>
  state.getIn(['app', 'mra', 'mra', 'calculateState']);
